import { Button, Form, Input, Modal, Space, Tag, Typography } from "antd";
import { SpellCheckTextArea, SpellCheckInput } from "../../../../../components/spellcheck";
import React from "react";

const { Text } = Typography;

const CreateTemplateModal = ({
  visible,
  onClose,
  templateForm,
  onCreateTemplate,
  onInsertTag,
}) => {
  return (
    <Modal
      title={
        <Space align="center">
          <span>📄</span>
          <span style={{ fontSize: 16, fontWeight: 600 }}>
            Create New Template
          </span>
        </Space>
      }
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={640}
      centered
      destroyOnClose
    >
      <Form form={templateForm} layout="vertical" onFinish={onCreateTemplate}>
        <Form.Item
          name="name"
          label="Template Name"
          rules={[{ required: true, message: "Please enter a template name" }]}
        >
          <Input placeholder="e.g., Fee Reminder, Holiday Alert" allowClear />
        </Form.Item>

        <Form.Item
          name="subject"
          label="Subject"
          rules={[{ required: true, message: "Please enter a subject" }]}
        >
          <SpellCheckInput placeholder="Message subject" allowClear />
        </Form.Item>

        {/* Dynamic tag helpers */}
        <div style={{ marginBottom: 12 }}>
          <Text type="secondary" style={{ fontSize: 12, marginRight: 8 }}>
            Click to insert:
          </Text>
          <Tag
            color="blue"
            className="cursor-pointer"
            style={{ cursor: "pointer" }}
            onClick={() => onInsertTag("{{parent_name}}")}
          >
            + Parent Name
          </Tag>
          <Tag
            color="green"
            className="cursor-pointer"
            style={{ cursor: "pointer" }}
            onClick={() => onInsertTag("{{student_name}}")}
          >
            + Student Name
          </Tag>
          <Tag
            color="orange"
            className="cursor-pointer"
            style={{ cursor: "pointer" }}
            onClick={() => onInsertTag("{{class_name}}")}
          >
            + Class Name
          </Tag>
        </div>

        <Form.Item
          name="content"
          label="Message Content"
          rules={[
            { required: true, message: "Please enter the message content" },
          ]}
        >
          <SpellCheckTextArea
            rows={4}
            placeholder="Write your message here. Use the buttons above to add dynamic names."
            showCount
            maxLength={2000}
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <Button type="primary" htmlType="submit">
            Save Template
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateTemplateModal;
